import { useRef } from "react";

const SCROLL_LOCK_CLASS = "lock-scroll";
const WRAPPER_ELEMENT = "#__next"; // NOTE: This does not use the actual `body` element so that overflow scrollTop can be set when the lock is active

// NOTE: this is so the hook can be safely run on the server
const getWrapper = () => document.querySelector(WRAPPER_ELEMENT);

export function useLockBodyScroll() {
  // state in a ref because there's no need to re-render when the lock state changes
  const isLocked = useRef(false);
  // Track scroll position so that it can be restored when the lock is removed
  const scrollTop = useRef(0);

  function lockScroll() {
    const wrapper = getWrapper();
    if (!wrapper) return;
    scrollTop.current = window.scrollY;
    isLocked.current = true;
    wrapper.classList.add(SCROLL_LOCK_CLASS);
    // Scroll the wrapper, rather than setting an offset via `top` or `transform`.
    wrapper.scroll(0, scrollTop.current);
  }

  function unlockScroll() {
    const wrapper = getWrapper();
    if (!wrapper) return;
    isLocked.current = false;
    wrapper.classList.remove(SCROLL_LOCK_CLASS);
    window.scrollTo(0, scrollTop.current);
  }

  return {
    lockScroll,
    unlockScroll,
    isLocked: isLocked.current,
  };
}
